export default [
  {
    path: '/:locale([en/]*)?/place',
    name: 'Place',
    component: () => import('@/views/place/Index'),
    meta: {
      sitemap: {
        loc: '/place'
      }
    }
  }
]
